import { jsx as _jsx } from "react/jsx-runtime";
import { WorkspaceMemberRoleDisplayName, WorkspaceMemberType } from "@air/api/types";
import { createContext, useContext, useMemo } from "react";
import { useFetchMembers } from "~/swr-hooks/members/useFetchMembers";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
import { useAccountContext } from "./AccountProvider";
import { useWorkspaceRolesContext } from "./WorkspaceRolesProvider";
const defaultValue = {
    currentWorkspaceMember: undefined
};
const CurrentWorkspaceMemberProviderContext = /*#__PURE__*/ createContext(defaultValue);
export const CurrentWorkspaceMemberProvider = (param)=>{
    let { children } = param;
    const { data: members } = useFetchMembers();
    const { data: roles } = useWorkspaceRolesContext();
    const { data: account } = useAccountContext();
    const data = useMemo(()=>{
        const currentMember = members === null || members === void 0 ? void 0 : members.find((member)=>member.accountId === (account === null || account === void 0 ? void 0 : account.id));
        const role = roles === null || roles === void 0 ? void 0 : roles.find((param)=>{
            let { id } = param;
            return id === (currentMember === null || currentMember === void 0 ? void 0 : currentMember.roleId);
        });
        return {
            currentWorkspaceMember: currentMember ? {
                ...currentMember,
                role,
                isSysAdmin: (role === null || role === void 0 ? void 0 : role.type) === WorkspaceMemberType.sysadmin,
                isWorkspaceOwner: !(role === null || role === void 0 ? void 0 : role.isCustom) && (role === null || role === void 0 ? void 0 : role.displayName) === WorkspaceMemberRoleDisplayName.WorkspaceOwner
            } : undefined
        };
    }, [
        account === null || account === void 0 ? void 0 : account.id,
        members,
        roles
    ]);
    return /*#__PURE__*/ _jsx(CurrentWorkspaceMemberProviderContext.Provider, {
        value: data,
        children: children
    });
};
export const useCurrentWorkspaceMemberContext = ()=>{
    const context = useContext(CurrentWorkspaceMemberProviderContext);
    if (context === defaultValue) {
        const error = "CurrentWorkspaceMemberProviderContext used outside of CurrentWorkspaceMemberProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
